export default __webpack_public_path__ + "static/media/BIFI-QUICK.331eb9e4.png";